'use client';

import dynamicImport from 'next/dynamic';

import type { Testimonial } from './types';

// Skeleton for the carousel area only — prevents CLS when Embla JS loads.
const CarouselSkeleton = () => (
  <div className="min-h-[200px] animate-pulse rounded-lg bg-white/10" />
);

const LazyEmblaSection = dynamicImport(() => import('./embla-section'), {
  ssr: false,
  loading: CarouselSkeleton,
});

export default function EmblaSectionClient({
  testimonials,
}: {
  testimonials: readonly Testimonial[];
}) {
  return <LazyEmblaSection testimonials={testimonials} />;
}
